module.exports = __webpack_public_path__ + "assets/group-3.7707471f5dda0d679de9109800cda952.png";